import { FC } from 'react';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import { AlertStyled } from './style';
import { Props, Type } from './types';

const getIcon = (type: Type) => {
  switch (type) {
    case 'warning': {
      return <WarningIcon />;
    }
    case 'error': {
      return <ErrorIcon />;
    }
    case 'success': {
      return <CheckCircleIcon />;
    }
    case 'info': {
      return <InfoIcon />;
    }
    default:
      return null;
  }
};

const Alert: FC<Props> = ({ id, type, show, children, ...restProps }) => {
  if (show) {
    return (
      <AlertStyled id={id} type={type} {...restProps}>
        {getIcon(type)}
        {children}
      </AlertStyled>
    );
  }

  return null;
};

export default Alert;
